<template>
  <div>
  <b-row>
      <b-col class="col-12">
        
        <div class="container-interactions">
          <b-avatar class="avatar-style" size="5rem" :src="getImageInfluencer(content.influencer)"/>
          <b-link @click="$emit('action-side-search', content.influencer)">
          <span class="influencer-username text-center text-dark"> {{ content.influencer.name }} 
          <image-verified v-if="content.influencer.is_verified == true"/></span>
          <h5 class="text-blue font-weight-bolder text-center">
            @{{ getUsername(content.influencer)}}
          </h5>
          </b-link>
          <b-avatar class="icon-network-contents" variant="ligth">
            <b-img :src="getIconWhite(content.network)" :class="getIconColor(content.network)" fluid/>
          </b-avatar>

          <div class="text-center">
            <b-button 
                size="sm"
                @click="openModalContent(content)"
                class="blue-button-new"
                variant="blue-button-new"
                style="margin-top: -3em;"
              >
                Ver contenido publicado
              </b-button>
            <span class="d-block">{{ $t('campaigns.contentType') }} {{ getLabelContentType(content) }}</span>
            <span>{{ $t('campaigns.platform') }} {{ (capitalize(content.network)) }}</span>
            <span :class="`${getStatusContent(content.status)} margin-status`">{{ $t(`campaigns.${content.status}`) }}</span>
            <span class="text-muted mr-1">{{ $t('campaigns.updated') }}:</span>
            <span >{{`${getDatev2(new Date(content.updated_at))}`}}</span>
        </div>

        
        <div class="col-12 row">
          <div class="mt-1 col-6 col-sm-4 col-lg-6 col-xl-4" v-for="(i, index) in content.metrics" :key="index">
            <div class="d-flex align-items-center justify-content-center">
              <b-icon class="mr-1" :icon="`${getIconInteractions(i.name)}`"/>
              <span>{{ `${getFormat(i.value)}` }}</span>
            </div>
          </div>
        </div>

        </div> 
      </b-col>
    </b-row>
    <modal-content 
      :open_modal="open_modal_content"
      :asset_url="asset_modal" 
      :type_content="content_type_modal"
      @close_modal="open_modal_content = false"
      :download="can_download"
      :uuid_img="content.uuid"
      :key="update_modal_content"
    />
  </div>
</template>
<script>
import { BRow, BCol, BIcon, BImg, BAvatar, BButton, BLink, } from 'bootstrap-vue';
import ImageVerified from '@/views/components/image/ImageVerified.vue';
import { getIconWhite, getIconColor, getContent, getIconInteractions } from '@/libs/utils/icons'
import { getImageInfluencer } from '@/libs/utils/others';
import { getStatusContent } from '@/libs/utils/series_graphs';
import { getDatev2 } from "@/libs/utils/times";
import { getFormat, capitalize, isVideo } from '@/libs/utils/formats';
import { getAssetUrl } from '@/libs/utils/urls';

export default {
  name: 'Interactions',
  props: {
   
    index: {
      type: Number,
      default: 0
    },
    content: {
      type: Object,
      required: true
    },
  },
  components: {
    ModalContent: () => import('@/views/components/modal/ModalContent.vue'),
    ImageVerified,
    BRow,
    BCol,
    BIcon,
    BImg,
    BAvatar,
    BButton,
    BLink,
  },
  data () {
    return {
      isVideo,
      capitalize,
      getAssetUrl,
      getFormat,
      getIconInteractions,
      getDatev2,
      getStatusContent,
      getImageInfluencer,
      getContent,
      getIconWhite,
      getIconColor,
      open_modal_content: false,
      content_type_modal: '',
      asset_modal: '',
      update_modal_content: false,
      can_download: false,
    }
  },
  methods: {
    getUsername(influencer) {
      if (influencer.network === "youtube") return influencer.name;
      return influencer.username;
    },
    openModalContent(content) {
      if (content.content_type !== 'story') {
        const url = this.getUrl(content);
        window.open(url, '_blank');
      } else {
        this.open_modal_content = true;
        this.asset_modal = content.image_content;
        this.content_type_modal = isVideo(content.image_content) ? 'video' : 'image';
        this.update_modal_content = !this.update_modal_content
        this.can_download = true
        
      }
    },
    getLabelContentType(content) {
      if (content.network === 'tiktok' && content.content_type === 'reel') return this.$t(`invitation.videoVertical`)
      if (content.network === 'blog' && content.content_type === 'post') return 'Blog Post'
      if (content.network === 'snapchat' && content.content_type === 'reel') return 'Spotlight'
      if (content.network === 'youtube' && content.content_type === 'reel') return 'Short'
      return this.$t(`invitation.${content.content_type}`)
    },
    getUrl(content) {
      if (content.image_content) return content.image_content
      return content.url_info
    },
    getImage(influencer) {
      if (influencer.file_for_profile)
        return getAssetUrl(influencer.file_for_profile);
      else 
        return influencer.profile_url;
    },
  },
}
</script>

<style>
.icon-network-contents {
  position: relative;
  width: 28px !important;
  height: 28px !important;
  left: 23px;
  bottom: 82px;
}
.container-interactions {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  bottom: 5em;
}
.avatar-style {
  padding: 5px;
  background-color: light;
}
.influencer-username {
  margin-top: 1rem;
  font-weight: bold;
}
.margin-status{
  display: flex;
  justify-content: center;
  margin: 0px 0px 10px 0px !important;
}
</style>

